
(function() {

const VendorsJsonElement = document.querySelector('#vendors-json'); 
const FullData = JSON.parse(VendorsJsonElement.innerHTML);
const BrandListSection = document.querySelector("#brand-list-sections");

const generateDataForSection = (data) => {
  const result = {}
  data.forEach(element => {
    const firstCharacter = element.charAt(0).toLowerCase();
    let index = ''
    if (firstCharacter.match(/[a-z]/i) == null) {
      index = '#'
    } else {
      index = firstCharacter
    }

    if (index in result) {
      result[index].push(element) 
    } else {
      result[index] = []
      result[index].push(element)
    }
  });

  return result;
}

const generateSectionHeader = (title) => {
  const sectionHeaderWrapper = document.createElement('div')
  const sectionHeader = document.createElement("h5");
  sectionHeaderWrapper.classList.add("brand-list-section-title");
  sectionHeader.innerText = title
  sectionHeaderWrapper.appendChild(sectionHeader)
  return sectionHeaderWrapper
}

const generateSectionList = (data) => {
  const listEl = document.createElement("ul");
  listEl.classList.add("brand-list-section-container"); 
  
  data.forEach(item => {
    const listItemEl = document.createElement("li");
    const listItemLinkEl = document.createElement("a");
    const handle = item.replace(/\s+/g, '-')        // space to -
                       .replace(/&/g, 'and')        // & to 'and'
                       .replace(/[^\w\-]+/g, '')    // remove special chars
                       .toLowerCase();
    const listItemLink = `/collections/${handle}` 
    
    listItemLinkEl.href = listItemLink;
    listItemLinkEl.innerText = item;
    listItemEl.dataset.itemReference = item;
    listItemEl.dataset.hidden = 'false'
    listItemEl.classList.add("brand-list-section-item"); 
    listItemEl.appendChild(listItemLinkEl);
    listEl.appendChild(listItemEl);
  });

  return listEl
}

const generateSectionElement = (data) => {
  Object.keys(data).forEach((el) => {
    const sectionEl = document.createElement("div");
    sectionEl.dataset.sectionReference = el;
    sectionEl.setAttribute('id', `brand-${el}`);
    
    const sectionHeader = generateSectionHeader(el);
    const sectionList = generateSectionList(data[el]);
    sectionEl.appendChild(sectionHeader)
    sectionEl.appendChild(sectionList)
    BrandListSection.appendChild(sectionEl)
  })
  
}



const brandListSectionsData = generateDataForSection(FullData)

generateSectionElement(brandListSectionsData)


// Popular Brands

const popularBrandItems = document.querySelectorAll('.popular-brand-item-link');

popularBrandItems.forEach((item) =>{
  const url = `https:${item.getAttribute("data-bg")}`;
  item.style.backgroundImage = `url(${url})`;
})

// Brands Filter

const brandsFilterLetterContainer = document.querySelector('#brands-filter-letters');
const brandsFilterInput = document.querySelector('#search-brands-input');
const brandsSectionsRef = document.querySelectorAll('[data-section-reference]')
const linkElements = document.querySelectorAll(`[data-item-reference]`);

const scrollToChosenEL = (letter) => {
  const selectorToLook = `[data-section-reference="${letter.toLowerCase()}"]`
  const elementToScroll = document.querySelector(selectorToLook)
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: elementToScroll.offsetTop - 60
  })
}

const filterItemsByInput = (value) => {
  if (value.length > 0) {

    linkElements.forEach((el) => {
      const elRef = el.getAttribute('data-item-reference').toLowerCase();
      if (elRef.includes(value.toLowerCase())) {
        el.style.display = "block";
        el.dataset.hidden = 'false'
      } else {
        el.style.display = "none";
        el.dataset.hidden = 'true'
      }
    })

    brandsSectionsRef.forEach((sec) => {
      const sectionItems = sec.querySelectorAll('li');
      const results = Array.from(sectionItems).filter(obj => {
        return obj.dataset.hidden == 'false';
      });
      if (results.length <= 0) {
        sec.style.display = "none"
      } else {
        sec.style.display = "block"
      }
    
    })
  
  
  } else {
    brandsSectionsRef.forEach((sec) => {
      sec.style.display = "block";
    })
    linkElements.forEach((el) => {
      el.style.display = "block";
    })
  }
}

const generateFilterLetters = () => {
  const BaseCodeArray =  Array.from(Array(26)).map((e, i) => i + 65);
  const AlphabetArray = BaseCodeArray.map((letter) => String.fromCharCode(letter));

  AlphabetArray.unshift("#");

  AlphabetArray.forEach((letter) => {
    const filterItem = document.createElement('li');
    const filterItemButton = document.createElement('button');
    filterItem.classList.add("brands-filter-letters-item")
    filterItemButton.classList.add("brands-filter-letters-button")
    filterItemButton.dataset.reference = letter;
    filterItemButton.innerText = letter;
    filterItemButton.addEventListener('click', (e) => {
      scrollToChosenEL(e.target.getAttribute('data-reference'))
    });

    filterItem.appendChild(filterItemButton);

    brandsFilterLetterContainer.appendChild(filterItem);
  })
}

generateFilterLetters();

brandsFilterInput.addEventListener('input', (e) => {
  filterItemsByInput(e.target.value)
})
})();